import axios from 'axios';
import { handleDate, showDate, totalShow } from '../utilities';
import {
    GET_POLICIES,
    GET_POLICY,
    GET_STATICS,
    UPDATE_INFO_SUCURSALES,
    UPDATE_INFO_USERS,
    UPDATE_INFO_REGIONS,
    UPDATE_INFO_ZONES,
    UPDATE_POLICY,
    LOADING,
    SET_SIN,
    DELETE_SINISTER,
} from './types';
import { urladmin as url, options, params, credentials } from './webServices';

export function getPolicies(data) {
    return function (dispatch) {
        credentials(data);
        params.set('opcpm', 'Policies');
        params.set('codcia', data['cod-cia'] || '');
        params.set('codsec', data['cod-sec'] ? data['cod-sec'].map(sec => sec.value).join("!") : '');
        params.set('codsuc', data['cod-suc'] || '');
        params.set('codreg', data['cod-reg'] || '');
        params.set('codpme', data['est-pol'] ? data['est-pol'].map(est => est.value).join("!") : '');
        params.set('venusu', data['ven-usu'] || '');
        params.set('dnipol', data['dni-pol'] || '');
        params.set('iiipol', data['iii-pol'] || '');
        params.set('webpol', data['web-pol']);
        params.set('patpol', data['pat-pol']);
        params.set('subemp', data['sub-emp']);
        params.set('mawpol', data['maw-pol']);
        params.set('dfe-pol', handleDate(data['dfe-pol']) || '');
        params.set('hfe-pol', handleDate(data['hfe-pol']) || '');
        axios.post(url, params, options)
            .then((r) => {
                // console.log(r.data)
                const enterprises = [];
                const lastPage = Math.ceil(r.data.polizas?.length / totalShow);

                r.data.empresas?.forEach(empresa => {
                    enterprises.push({ value: empresa.codemp, label: empresa.nomemp });
                });
                const payload = {
                    enterprises,
                    policies: r.data.polizas.reverse(),
                    lastPage,
                };
                dispatch({ type: GET_POLICIES, payload });
                dispatch({ type: LOADING, payload: false });
                params.set('mawpol', '');
            })
    }
}

export function getPolicy(id) {
    return function (dispatch) {
        params.set('opcpm', 'Policy');
        params.set('codpmpol', id);
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                const cities = [];
                const policy = {
                    ...r.data.poliza[0],
                    'fec-pol': showDate(r.data.poliza[0]['fec-pol']),
                    'fv2-pol': showDate(r.data.poliza[0]['fv2-pol']),
                    'nac-pol': showDate(r.data.poliza[0]['nac-pol']),
                };
                r.data.ciudades?.forEach(ciudad => {
                    cities.push({ value: ciudad.codloc, label: ciudad.nomloc, codprv: ciudad.codprv });
                });
                const payload = {
                    policy,
                    cities,
                    payment: r.data.pagos,
                }
                dispatch({ type: GET_POLICY, payload });
                dispatch({ type: LOADING, payload: false });
            })
    }
}

export function updatePolicy(data) {
    return function (dispatch) {
        params.set('opcpm', 'Update');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                const payload = {
                    ...r.data,
                    'fec-pol': showDate(r.data['fec-pol']),
                    'fv1-pol': showDate(r.data['fv1-pol']),
                    'fv2-pol': showDate(r.data['fv2-pol']),
                    'nac-pol': showDate(r.data['nac-pol']),
                    edited: true,
                }
                dispatch({ type: UPDATE_POLICY, payload });
                dispatch({ type: LOADING, payload: false });
            })
    }
}

export function getSinisters(data) {
    return function (dispatch) {
        //console.log(data)
        credentials(data.user);
        params.set('opcpm', 'GetSinisters');
        params.set('fdefro', data.fdefro?.toLocaleDateString("en-GB")?.replaceAll("/", "-") || "");
        params.set('fdeto', data.fdeto?.toLocaleDateString("en-GB")?.replaceAll("/", "-") || "");
        params.set('fpafro', data.fpafro?.toLocaleDateString("en-GB")?.replaceAll("/", "-") || "");
        params.set('fpato', data.fpato?.toLocaleDateString("en-GB")?.replaceAll("/", "-") || "");
        params.set('codsec', data.codsec);
        params.set('codpes', data.codpes);
        params.set('polsin', data.ciapol);
        params.set('dni', data.dni);
        params.set('sinsin', data.sinsin);
        axios.post(url, params, options)
            .then(r => {
                //console.log(r.data);
                let arr = [];
                r.data.forEach(sin => {
                    let res = data.vendors.find(vendor => vendor['nom-usu'] === sin['nom-usu'])
                    arr.push({ ...sin, 'ven-usu': res?.value })
                })
                dispatch({ type: SET_SIN, payload: arr });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function getStatics(data) {
    return function (dispatch) {
        credentials(data);
        params.set('opcpm', 'Statics');
        params.set('tipo', data.type);
        params.set('year', data.year);
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data);
                const datasets = [];
                const colors = [
                    'rgba(234, 14, 201, 0.7)',
                    'rgba(251, 73, 35, 0.7)',
                    'rgba(35, 140, 251, 0.7)',
                    'rgba(14, 234, 37, 0.7)',
                    'rgba(231, 234, 14, 0.7)',
                    'rgba(135, 158, 175, 0.7)',
                    'rgba(135, 60, 140, 0.7)',
                    'rgba(135, 20, 180, 0.7)',
                ];

                r.data.estmen?.forEach((venta, ix) => {
                    datasets.push({
                        label: venta.nomsec,
                        data: venta.canven,
                        backgroundColor: colors[ix],
                    });
                });

                dispatch({ type: GET_STATICS, payload: { ...r.data, type: data.type, datasets } });
                dispatch({ type: LOADING, payload: false });
            });
    };
};

// ------------------------------ Update Data ------------------------------ //

export function updateUsers(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'UpdateUsers');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_USERS, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function deleteUsers(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'DeleteUsers');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_USERS, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function updateSucursales(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'UpdateSucursales');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_SUCURSALES, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function deleteSucursales(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'DeleteSucursales');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_SUCURSALES, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function updateRegions(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'UpdateRegions');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_REGIONS, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function deleteRegions(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'DeleteRegions');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_REGIONS, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function updateZones(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'UpdateZones');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_ZONES, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

export function deleteZones(data, user) {
    return function (dispatch) {
        credentials(user);
        params.set('opcpm', 'DeleteZones');
        params.set('data', JSON.stringify(data));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data)
                dispatch({ type: UPDATE_INFO_ZONES, payload: r.data });
                dispatch({ type: LOADING, payload: false });
            });
    }
}

// ------------------------------ Siniestros ------------------------------ //

export function newSinister(data, beneficiaries, user) {
    return function () {
        credentials(user);
        params.set('opcpm', 'NewSinister');
        params.set('data', JSON.stringify(data));
        params.set('beneficiaries', JSON.stringify(beneficiaries));
        axios.post(url, params, options)
            .then((r) => {
                //console.log(r.data);
            });
    }
}

export function deleteSinister(id, user) {
    return async function (dispatch) {
        credentials(user);
        params.set('opcpm', 'DeleteSinister');
        params.set('id', id);
        axios.post(url, params, options)
            .then(r => {
                //console.log('respuesta: ', r.data)
                if (r.data.success) dispatch({ type: DELETE_SINISTER, payload: r.data.success });
                else dispatch({ type: DELETE_SINISTER, payload: 'error' });
            })
            .catch(r => {
                //console.log(r, 'error')
            });
    }
}


